// eslint-disable-next-line no-shadow
enum Icons {
  ARROW_DOWN = 'arrow-down',
  ARROW_UP = 'arrow-up',
}

export default Icons
